// PGCET MCA Mock 3 — General English (questions 91–100), drawn from the Karnataka PGCET 2026 MCA paper
const PASSAGE = "\"Technology has transformed the way people communicate. In the past, letters took days or even weeks to reach their destination. Today, messages can be sent instantly through e-mails and mobile applications. While this has made communication faster and more convenient, it has also reduced face-to-face interactions. Many people now prefer texting over meeting in person, which may affect social relationships in the long run.\"";

const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: `Match the underlined verb forms in List-I with the non-finites in List-II.
      List-I: (a) "Swimming is good exercise." (b) "She wants to learn French." (c) "The broken window was repaired." (d) "Having finished the work, he left."
      List-II: (i) Perfect participle (ii) Infinitive (iii) Past participle (iv) Gerund`,
    options: [
      "A. a-iv, b-ii, c-iii, d-i",
      "B. a-iv, b-i, c-ii, d-iii",
      "C. a-ii, b-iii, c-i, d-iv",
      "D. a-ii, b-i, c-iii, d-iv"
    ],
    answer: "A"
  },
  {
    id: 92,
    question: `Match the clauses in List-I with their functions in List-II.
      List-I: (a) "What he said was true." (b) "I know that she is honest." (c) "The man who called you is my uncle." (d) "He left because he was tired."
      List-II: (i) Adjective clause qualifying a noun (ii) Noun clause as subject (iii) Adverb clause of reason (iv) Noun clause as object`,
    options: [
      "A. a-ii, b-iii, c-i, d-iv",
      "B. a-iv, b-ii, c-iii, d-i",
      "C. a-iii, b-iv, c-ii, d-i",
      "D. a-ii, b-iv, c-i, d-iii"
    ],
    answer: "D"
  },
  {
    id: 93,
    question: "Choose the correct word to complete the sentence: His speech was so ______ that everyone lost interest halfway through.",
    options: ["A. Engaging", "B. Monotonous", "C. Lively", "D. Exciting"],
    answer: "B"
  },
  {
    id: 94,
    question: `Read the passage and answer the question: ${PASSAGE} How were messages sent in the past?`,
    options: ["A. Through mobile apps", "B. Through e-mails", "C. Through letters", "D. Through video calls"],
    answer: "C"
  },
  {
    id: 95,
    question: `Read the passage and answer the question: ${PASSAGE} What is one advantage of modern communication?`,
    options: ["A. It is slower", "B. It is more expensive", "C. It is instant", "D. It requires travel"],
    answer: "C"
  },
  {
    id: 96,
    question: `Read the passage and answer the question: ${PASSAGE} What is one disadvantage of modern communication mentioned in the passage?`,
    options: ["A. Increased travel", "B. Reduced face-to-face interaction", "C. Higher costs", "D. Lack of technology"],
    answer: "B"
  },
  {
    id: 97,
    question: `OBFUSCATE nearly means:
      (a) Illuminate
      (b) Confound
      (c) Explicate
      (d) Muddle`,
    options: ["A. (a) and (b) are correct", "B. (b) and (c) are correct", "C. (b) and (d) are correct", "D. (a) and (c) are correct"],
    answer: "C"
  },
  {
    id: 98,
    question: `Choose the antonyms of LOQUACIOUS.
      (a) Garrulous
      (b) Voluble
      (c) Reticent
      (d) Taciturn`,
    options: ["A. (a) and (b) are correct", "B. (b) and (c) are correct", "C. (c) and (d) are correct", "D. (d) and (a) are correct"],
    answer: "C"
  },
  {
    id: 99,
    question: "Choose the correct meaning of the phrase \"a blessing in disguise\".",
    options: ["A. A hidden danger", "B. A very obvious problem", "C. A happy occasion", "D. Something that seems bad but turns out to be good"],
    answer: "D"
  },
  {
    id: 100,
    question: `Arrange the sentences in the correct order.
      (A) The teacher appreciated her efforts.
      (B) She worked hard to complete the project on time.
      (C) Meena was assigned a project in the class.
      (D) She presented it confidently before everyone.`,
    options: ["A. C B D A", "B. B C D A", "C. C D B A", "D. B D C A"],
    answer: "A"
  }
];

export default pgcetmcaGeneralEnglish;
